import chroma from 'chroma-js';

const shades = [
  '50',
  '100',
  '200',
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900',
  '950'
];

const EMPTY_COLOR = '0 0 0';

/**
 * Convert color to RGB values, for use with Tailwind CSS variables.
 */
export const colorToRgb = (color) => {
  if (!color) {
    return EMPTY_COLOR;
  }

  return chroma(color)
    .rgb()
    .map((v) => {
      if (Number.isNaN(v)) {
        return 0;
      }

      return Math.round(v);
    })
    .slice(0, 3) // Remove alpha channel if present
    .join(' ');
};

/**
 * Set a single tailwind color shade from a hex value.
 */
export function switchColor(name, shade, color) {
  const rgb = colorToRgb(color);
  window.document.documentElement.style.setProperty(
    `--color-${name}-${shade}`,
    rgb
  );
}

/**
 * Set a tailwind color complete shade.
 */
// eslint-disable-next-line no-shadow
export function switchColorShades(name, shades) {
  Object.entries(shades).forEach(([shade, color]) => {
    switchColor(name, shade, color);
  });
}

/**
 * Reset all shades of a color.
 */
export function resetColor(name) {
  // eslint-disable-next-line no-restricted-syntax
  for (const shade of shades) {
    window.document.documentElement.style.removeProperty(
      `--color-${name}-${shade}`
    );
  }
}

export const colors = {
  legacy: {
    primary: {
      50: '#f3f7fb',
      100: '#e4ebf5',
      200: '#cfddee',
      300: '#aec6e2',
      400: '#87a8d3',
      500: '#6b8cc6',
      600: '#5875b9',
      700: '#4d64a8',
      800: '#43538a',
      900: '#39466f',
      950: '#262d45'
    },
    muted: {
    }
  },
  blue: {
    primary: {
      50: '#f2f7fc',
      100: '#e1edf8',
      200: '#c9dff4',
      300: '#a4ccec',
      400: '#79b0e1',
      500: '#5993d8',
      600: '#457acb',
      700: '#3b66ba',
      800: '#324f8e',
      900: '#2f4879',
      950: '#212d4a'
    },
    muted: {
    }
  },
  green: {
    primary: {
      50: '#effcfc',
      100: '#d7f6f6',
      200: '#b4eced',
      300: '#80dee0',
      400: '#37c0c6',
      500: '#29a9b1',
      600: '#258995',
      700: '#246f7a',
      800: '#255b65',
      900: '#234d56',
      950: '#12333a'
    },
    muted: {
    }
  }
};

export const darkModeToggle = (isDark = false) => (isDark ? document.documentElement.classList.add('dark') : document.documentElement.classList.remove('dark'));
